// ABOUTME: Step 1 of MFA setup - displays QR code for authenticator app scanning.
// ABOUTME: Also shows manual entry key for users who can't scan.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ProgressionTab from "../../../../theme/ProgressionBuilder/ProgressionTab";
import Text from "../../../../theme/text/Text";
import Subheading from "../../../../theme/text/Subheading";
import { tokens } from "../../../../../theme";

const Content = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const setupData = props.setupData;

    return (
        <Box sx={{ textAlign: "center", py: 1, px: 2 }}>
            <Text light align="center" sx={{ mb: 2, maxWidth: 360, mx: "auto", display: "block" }}>
                {t("scan_qr_description")}
            </Text>

            {setupData?.qrCodeUrl && (
                <Box sx={{ mb: 2 }}>
                    <Box
                        component="a"
                        href={setupData.otpauthUrl}
                        sx={{
                            display: "block",
                            width: 180,
                            mx: "auto",
                            textDecoration: "none",
                        }}
                    >
                        <Box
                            component="img"
                            src={setupData.qrCodeUrl}
                            alt="MFA QR Code"
                            sx={{
                                width: 180,
                                height: 180,
                                display: "block",
                                borderRadius: 2,
                                border: `1px solid ${colors.grey[200]}`,
                            }}
                        />
                    </Box>
                </Box>
            )}
            <Box sx={{ textAlign: "center" }}>
                <Text light align="center" sx={{ mb: 1, display: "block" }}>
                    {t("cant_scan_enter_manually")}
                </Text>

                <Box
                    sx={{
                        fontFamily: "monospace",
                        fontSize: "14px",
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                        display: "inline-block",
                        px: 2,
                        py: 1,
                        borderRadius: "6px",
                        letterSpacing: "2px",
                        userSelect: "all",
                    }}
                >
                    {setupData?.secret}
                </Box>
            </Box>
        </Box>
    );
};

const ScanQr = (props) => {
    const { t } = useTranslation();

    return (
        <ProgressionTab
            tabId="tabScanQr"
            subtitle={t("scan_qr_code")}
            step={1}
            maxSteps={3}
            nextTab="tabVerifyCode"
        >
            <Content setupData={props.setupData} />
        </ProgressionTab>
    );
};

export default ScanQr;
